var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 5.40982L6.70995 1.16982C6.61699 1.07609 6.50638 1.0017 6.38453 0.950931C6.26267 0.900162 6.13196 0.874023 5.99995 0.874023C5.86794 0.874023 5.73723 0.900162 5.61537 0.950931C5.49351 1.0017 5.38291 1.07609 5.28995 1.16982L1.04995 5.40982C0.95622 5.50278 0.881826 5.61339 0.831057 5.73524C0.780288 5.8571 0.75415 5.98781 0.75415 6.11982C0.75415 6.25183 0.780288 6.38254 0.831057 6.5044C0.881826 6.62626 0.95622 6.73686 1.04995 6.82982C1.23731 7.01607 1.49076 7.12061 1.75495 7.12061C2.01913 7.12061 2.27259 7.01607 2.45995 6.82982L5.99995 3.28982L9.53995 6.82982C9.72621 7.01457 9.97761 7.11872 10.2399 7.11982C10.3716 7.12058 10.502 7.09536 10.6239 7.04559C10.7457 6.99583 10.8565 6.9225 10.9499 6.82982C11.047 6.7402 11.1254 6.63224 11.1805 6.51216C11.2356 6.39209 11.2664 6.26228 11.271 6.13025C11.2757 5.99821 11.2541 5.86656 11.2076 5.74291C11.161 5.61926 11.0905 5.50605 10.9999 5.40982Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.dccefc0eb401868c3a34b27689f5c308.svg";
export { ForwardRef as ReactComponent };